import { render } from "./LocumTenens.vue?vue&type=template&id=6aa74111&scoped=true"
import script from "./LocumTenens.vue?vue&type=script&lang=js"
export * from "./LocumTenens.vue?vue&type=script&lang=js"

import "./LocumTenens.vue?vue&type=style&index=0&id=6aa74111&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa74111"]])

export default __exports__